var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.333 3.167c0-.46.373-.834.833-.834h3.89a.28.28 0 0 0 .277-.277V.944a.28.28 0 0 0-.278-.277H3.166a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5v-3.889a.28.28 0 0 0-.278-.277h-1.11a.28.28 0 0 0-.279.277v3.89c0 .46-.373.833-.833.833H3.166a.833.833 0 0 1-.833-.834z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.944 2.333h3.544L8.607 8.214a.28.28 0 0 0 0 .393l.786.786a.28.28 0 0 0 .393 0l5.88-5.881v3.544c0 .153.125.277.278.277h1.111a.28.28 0 0 0 .278-.277V1.5A.833.833 0 0 0 16.5.667h-5.556a.28.28 0 0 0-.278.277v1.112c0 .153.125.277.278.277"
  })));
};
export default SvgShare;